import React, { useContext, useEffect } from "react";
import styles from "./styles.module.sass";
// hooks
import { useDispatch } from "react-redux";
// antd
import { Row, Col } from "antd";
// components
import {
  WelcomeMessage,
  CustomersSegment,
  CustomersVisits,
  OverallProgress,
  HomeNavigationCards,
  BranchesPerformance,
  TodaysProgress,
} from "./components";
// actions
import { getStore, getBranches } from "../../../../redux-store/actions";
import { LiveUpdates } from "./components/LiveUpdates";
import Strings from "../../../../i18n/Manager/strings/home";
import "./styles.less";
import { useSelect } from "../../../../hooks/useSelect";
import { useTranslation } from "../../../../shopx-shared-components/hooks/useTranslation";
import i18n from "../../../../i18n/i18n";
import RocketTitleIcon from "../../../../assets/reviews/rocket-title.svg";
import Reviews from "./components/Reviews";
import { trackEvent } from "../../../../tracking/trackEvent";
import { EVENTS_FOR_TRACKING } from "../../../../constants/events-for-tracking";
import {
  AmplitudeEvents,
  amplitudeLogEvent,
} from "../../../../tracking/amplitude";
import StoreData from "../../../../contexts/StoreData";
import { useUserAccess } from "../../../../Components/AuthenticatedRoutes";


const Home: React.FC = () => {
  const dispatch = useDispatch();

  const store = useSelect((state) => state.storeReducer.store);
  const { storeData, userData } = useContext(StoreData);
  const { t } = useTranslation("home");
  const { demoMode } = useUserAccess();
  useEffect(() => {
    dispatch(getStore());
    dispatch(getBranches());
  }, [dispatch]);

  useEffect(() => {
    trackEvent(EVENTS_FOR_TRACKING["Viewed home page"]);
    amplitudeLogEvent(AmplitudeEvents.home_page, {
      user_name: userData?.name,
      user_id: userData?.id,
      user_role: userData?.title || userData?.role,
      store_id: storeData?.id,
      store_name: storeData?.name,
    });
  }, [userData?.name, userData?.id, userData?.title, userData?.role, storeData?.id, storeData?.name]);

  return (
    <div className={styles.pageWrapper}>
      <Row>
        <Col span={24}>
          <WelcomeMessage />
        </Col>
      </Row>
      {/* <Row>
        <Col span={24}>
          <TodaysProgress />
        </Col>
      </Row> */}
      <Row>
        <Col span={24} className={styles.overAllProgressWrapper}>
          <OverallProgress />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <HomeNavigationCards />
        </Col>
      </Row>
      <Row justify={"space-between"} className={styles.performanceWrapper}>
        <Col span={24}>
          <div className={styles.performanceTitle}>
            <img src={RocketTitleIcon} className={styles.icon} alt="" />
            <span className={styles.text}>
              {(() => {
                const message = t(Strings.store_performance, { store_name: "{STORE_NAME}" });
                const parts = message.split("{STORE_NAME}");
                return (
                  <>
                    {parts[0]}
                    <span style={{ ...(demoMode ? { filter: 'blur(5px)', pointerEvents: 'none' } : {}) }}>
                      {i18n.language === "ar" ? store.ar_name : store.en_name}
                    </span>
                    {parts[1]}
                  </>
                );
              })()}
            </span>
          </div>
        </Col>
        <Col span={11}>
          <Reviews />
        </Col>
        <Col className={styles.performanceTable} span={13}>
          <BranchesPerformance />
        </Col>
      </Row>
      <Row>
        <Col span={24} className={styles.factsWrapper}>
          <div className={styles.factsContainer}>
            <div className={styles.factsIconWrapper}>
              <img
                src={
                  require("../../../../assets/reviews/icon_solid_search.svg")
                    .default
                }
                className={styles.factsIcon}
                alt=""
              />
            </div>
            <span className={styles.factsLabel}>
              {" "}
              {(() => {
                const storeNameKey = i18n.language === "ar" ? "ar_store_name" : "en_store_name";
                const message = t(Strings.quick_facts_about, { [storeNameKey]: "{STORE_NAME}" });
                const parts = message.split("{STORE_NAME}");
                return (
                  <>
                    {parts[0]}
                    <span style={{ ...(demoMode ? { filter: 'blur(5px)', pointerEvents: 'none' } : {}) }}>
                      {i18n.language === "ar" ? store.ar_name : store.en_name}
                    </span>
                    {parts[1]}
                  </>
                );
              })()}
            </span>
          </div>
        </Col>
      </Row>

      <Row justify="space-between">
        <Col span={14}>
          <CustomersVisits />
          <CustomersSegment />
        </Col>
        <Col span={9}>
          <Row justify="center">
            <LiveUpdates />
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Home;
